import { Hint } from 'react-autocomplete-hint';
import { useState, useContext, useEffect } from 'react';
import { useQuery } from 'react-query';
import { FeedbackContext } from "../../../Components/Context/FeedbackContext";
import { Loading } from "../../../Components/Loading/Loading";
import { ErrorConnection } from "../../../Components/Error/Error";
import * as Api from '../../../api/Api';
import { useGetToken, useGetUser } from '../../../Hooks/CustomHooks';
import PermissionsGate from '../../../api/PermissionsGate';
import { SCOPES } from '../../../config/permissions-map';
import { Unauthorized } from '../../Global/unauthorized';
import * as Utilities from '../../../Components/Utils/Utils';
import { PageTitle } from '../../../../_metronic/layout/core';
import { registerLocale } from 'react-datepicker';
import DatePicker from 'react-datepicker';
import es from "date-fns/locale/es";
import "react-datepicker/dist/react-datepicker.css";
import SelectList from '../../../Components/Select/SelectList';
import Modal from 'react-bootstrap/Modal';
import Select from 'react-select'
import makeAnimated from 'react-select/animated';

export default function RegistroAmonestacion({ title }) {
    const user = useGetUser()
    const token = useGetToken();
    const [local, setLocal] = useState("");
    const [localId, setLocalId] = useState("");
    const [listaLocalesSearch, setListaLocalesSearch] = useState([]);
    const [modalLocalesShow, setModalLocalesShow] = useState(false);
    const [filterTextModal, setFilterTextModal] = useState("");

    const filteredLocales = listaLocalesSearch ? listaLocalesSearch.filter(item => {
        if (!filterTextModal) return true;
        const txt = filterTextModal.toUpperCase();
        const labelMatch = item.label ? String(item.label).toUpperCase().includes(txt) : false;
        const valueMatch = item.value ? String(item.value).toUpperCase().includes(txt) : false;
        const contratoMatch = item.contrato ? String(item.contrato).toUpperCase().includes(txt) : false;
        const codContratoMatch = item.codContrato ? String(item.codContrato).toUpperCase().includes(txt) : false;
        const denContMatch = item.denCont ? String(item.denCont).toUpperCase().includes(txt) : false;
        return labelMatch || valueMatch || contratoMatch || codContratoMatch || denContMatch;
    }) : [];

    const [tipoMotivo, setTipoMotivo] = useState({
        "value": "",
        "label": ""
    });
    const [getMotivosList, setGetMotivosList] = useState(false);

    const [motivo, setMotivo] = useState({
        "value": "",
        "label": ""
    });

    const [rdmML, setRdmML] = useState(Math.floor(Math.random() * 100))


    const [responsable, setResponsable] = useState((user.name) ? user.name : "");
    const [dni, setDni] = useState((user.dni) ? user.dni : "");
    const [detalle, setDetalle] = useState("");
    const [pictures, setPictures] = useState([]);


    const [registrar, setRegistrar] = useState(false);
    const [guardadoExitoso, setGuardadoExitoso] = useState(false);

    const [viewDanger_mall, setViewDanger_mall] = useState(false);
    const [viewDanger_local, setViewDanger_local] = useState(false);
    const [viewDanger_responsable, setViewDanger_responsable] = useState(false);
    const [viewDanger_detalle, setViewDanger_detalle] = useState(false);
    const [viewDanger_emailCopia, setViewDanger_emailCopia] = useState(false);
    const [viewDanger_tam, setViewDanger_tam] = useState(false);

    let unidadesEconomicasList = Utilities.getListUnidadesEconomicas(false)
    const [unidadEconomica, setUnidadEconomica] = useState(null);
    const [filterLocalList, setFilterLocalList] = useState(false);
    const [disabledLocalField, setDisabledLocalField] = useState(true);
    const animatedComponents = makeAnimated();
    const getOptionValue = idDefault => {
        return unidadesEconomicasList.list.filter(obj => obj.value === idDefault)
    }

    const onChangeUnidadEconomica = (inputValue) => {
        setUnidadEconomica(inputValue);
        setFilterLocalList(true)
    }

    const handleFileChange = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            const selectedFiles = Array.from(e.target.files);
            const validFiles = selectedFiles.filter(f => f.size <= 5242880);
            if (validFiles.length < selectedFiles.length) {
                alert("Algunos archivos superan el tamaño máximo permitido de 5MB.");
            }
            setPictures(prev => [...prev, ...validFiles]);
        }
        e.target.value = "";
    };


    registerLocale('es', es);
    const [fechaInicio, setFechaInicio] = useState(new Date());
    const [fechaFin, setFechaFin] = useState(new Date());
    const [emailCopia, setEmailCopia] = useState("");
    const [tam, setTam] = useState("");
    const [montoFinal, setMontoFinal] = useState("");

    let fechaInicioFormated = ("0" + fechaInicio.getDate()).slice(-2) + "/" + ("0" + (fechaInicio.getMonth() + 1)).slice(-2) + "/" + fechaInicio.getFullYear();
    let horaInicioFormated = fechaInicio.toLocaleTimeString('es-ES');
    let fechaFinFormated = ("0" + fechaFin.getDate()).slice(-2) + "/" + ("0" + (fechaFin.getMonth() + 1)).slice(-2) + "/" + fechaFin.getFullYear();
    let horaFinFormated = fechaFin.toLocaleTimeString('es-ES');

    const calculateDiasPenalidad = (inicio, fin) => {
        if (!inicio || !fin) return 1;
        const diffTime = fin.getTime() - inicio.getTime();
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        return diffDays > 0 ? diffDays : 1;
    };
    let diasPenalidad = calculateDiasPenalidad(fechaInicio, fechaFin);
    let valMontoPenalidad = parseFloat(tam) || 0;
    let treintavo = valMontoPenalidad > 0 ? (valMontoPenalidad / 30).toFixed(2) : "0.00";
    let montoFinalCalculado = valMontoPenalidad > 0 ? (parseFloat(treintavo) * diasPenalidad).toFixed(2) : "0.00";

    useEffect(() => {
        setMontoFinal(montoFinalCalculado);
    }, [montoFinalCalculado]);

    const { feedbackContext, setFeedbackContext } = useContext(FeedbackContext);
    let { data: dataListaLocales, isLoading: isLoadingListaLocales, isError: isErrorListaLocales, error, isFetching } = useQuery(
        ["ListaLocales", { "api": "ListaLocales" }], async () => await Api.ListaLocales({ unidadEconomica: unidadEconomica }), { enabled: filterLocalList }
    );

    // let {data: dataDni} = useQuery('GetDni',
    //     async () => await Api.GetDni({email: user.email, token: token}),
    //     {enabled: true}
    // )

    // useEffect(() => {
    //     if(dataDni) {
    //         if(dataDni.success) {
    //             setDni(dataDni.data.dni)
    //         }
    //     }
    // }, [dataDni])

    useEffect(() => {
        if (dataListaLocales) {
            if (dataListaLocales.data === null) {
                setFeedbackContext({ ...feedbackContext, showError: true, idError: dataListaLocales.errorId });
            }
            else {
                setListaLocalesSearch(dataListaLocales.data);
                setDisabledLocalField(false)
            }
            setFilterLocalList(false)
        }
    }, [dataListaLocales]);



    function readFile(file) {
        return new Promise((resolve, reject) => {
            // Create file reader
            let reader = new FileReader()

            // Register event listeners
            reader.addEventListener("loadend", e => resolve(e.target.result))
            reader.addEventListener("error", reject)

            // Read file
            reader.readAsArrayBuffer(file)
        })
    }


    function guardadoExistosoModal() {
        window.location.reload(false);
    }


    function handleRegistrar() {
        let isExternalRol = (user?.role?.id === '96' || user?.role?.id === '101');
        let hasError = false;

        if (!unidadEconomica) {
            setViewDanger_mall(true);
            hasError = true;
        } else {
            setViewDanger_mall(false);
        }

        if (!local || local === '') {
            setViewDanger_local(true);
            hasError = true;
        } else {
            setViewDanger_local(false);
        }

        if ((!responsable || responsable.trim() === '') && !isExternalRol) {
            setViewDanger_responsable(true);
            hasError = true;
        } else {
            setViewDanger_responsable(false);
        }

        const isEmailValid = Boolean(emailCopia && emailCopia.trim() !== "" && emailCopia.split(/[,;]/).every(e => {
            const trimmed = e.trim();
            return trimmed.length > 0 && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed);
        }));

        if (!isEmailValid) {
            setViewDanger_emailCopia(true);
            hasError = true;
        } else {
            setViewDanger_emailCopia(false);
        }

        const isTamValid = Boolean(tam !== "" && !isNaN(parseFloat(tam)) && parseFloat(tam) > 0);
        if (!isTamValid) {
            setViewDanger_tam(true);
            hasError = true;
        } else {
            setViewDanger_tam(false);
        }

        if (!detalle || detalle.trim() === '') {
            setViewDanger_detalle(true);
            hasError = true;
        } else {
            setViewDanger_detalle(false);
        }

        if (!hasError) {
            setRegistrar(true);
        }
    }

    let { data: dataRegistrar } = useQuery(
        ["RegistrarAmonestacion", {
            locatarioId: localId, tipoMotivo: tipoMotivo.value, motivo: motivo.value, responsable: responsable,
            dni: dni, fecha: fechaInicioFormated, hora: horaInicioFormated,
            fechaInicio: fechaInicioFormated, horaInicio: horaInicioFormated,
            fechaFin: fechaFinFormated, horaFin: horaFinFormated,
            emailCopia: emailCopia, tam: tam, montoPenalidad: tam,
            treintavo: treintavo, diasPenalidad: diasPenalidad, montoFinal: montoFinal,
            detalle: detalle, pictures: pictures
        }], async () => await Api.RegistrarAmonestacion({
            unidadEconomica: unidadEconomica.value,
            locatarioId: localId,
            tipoMotivo: tipoMotivo.value,
            motivo: motivo.value,
            responsable: responsable,
            dni: dni,
            fecha: fechaInicioFormated,
            hora: horaInicioFormated,
            fechaInicio: fechaInicioFormated,
            horaInicio: horaInicioFormated,
            fechaFin: fechaFinFormated,
            horaFin: horaFinFormated,
            emailCopia: emailCopia,
            tam: tam,
            montoPenalidad: tam,
            treintavo: treintavo,
            diasPenalidad: diasPenalidad,
            montoFinal: montoFinal,
            detalle: detalle,
            pictures: pictures,
            token: token
        }),
        { enabled: Boolean(registrar) }
    );
    useEffect(() => {
        if (dataRegistrar) {
            if (dataRegistrar.success === true) {
                setRegistrar(false);
                setGuardadoExitoso(true);
            } else {
                setFeedbackContext({ ...feedbackContext, showError: true, isError: dataRegistrar.errorId });
            }
        }
    }, [dataRegistrar]);

    // if (isLoadingListaLocales) return (<Loading />)
    if (isErrorListaLocales) return (<ErrorConnection error={error} />)

    return (
        <>
            <PermissionsGate RenderError={() => <Unauthorized />} scopes={[SCOPES.REGISTRO_AMONESTACION]} >
                <PageTitle>{title}</PageTitle>
                <div className="card my-5">
                    <div className="card-body tab-content">
                        <div className='row'>
                            <div className='d-flex flex-column mb-8 fv-row fv-plugins-icon-container col-6'>
                                <label className='fs-6 fw-bold mb-2'>Malls</label>
                                <Select
                                    classNamePrefix='filter'
                                    components={animatedComponents}
                                    defaultValue={getOptionValue(0)}
                                    isMulti={false}
                                    closeMenuOnSelect={true}
                                    options={unidadesEconomicasList.list}
                                    onChange={(onChangeUnidadEconomica)}
                                />
                                {viewDanger_mall && <span className="text-danger">Debe seleccionar un mall</span>}
                            </div>

                            <div className='d-flex flex-column mb-8 fv-row fv-plugins-icon-container col-6'>
                                <label className='fs-6 fw-bold mb-2'>Local</label>

                                <div className="input-group">
                                    <div className="flex-grow-1">
                                        <Hint options={listaLocalesSearch} allowTabFill>
                                            <input
                                                required
                                                style={{ textTransform: "uppercase" }}
                                                type="text"
                                                className="form-control form-control-solid rounded-end-0"
                                                placeholder="Ingrese el local"
                                                value={local}
                                                disabled={disabledLocalField}
                                                onChange={e => {
                                                    let locatario = (listaLocalesSearch.find(element => element.label == e.target.value.toUpperCase()));
                                                    if (locatario) setLocalId(locatario.value);
                                                    return setLocal(e.target.value.toUpperCase())
                                                }}
                                            />
                                        </Hint>
                                    </div>
                                    <button
                                        type="button"
                                        className="btn btn-primary btn-sm px-3 py-2 d-flex align-items-center fs-7"
                                        disabled={disabledLocalField}
                                        onClick={() => setModalLocalesShow(true)}
                                        title="Buscar contrato / local"
                                    >
                                        <i className="fi-rr-search me-1 fs-7"></i> Buscar
                                    </button>
                                </div>
                                <div className="fw-bold">
                                    <div className="fs-6 text-blue">
                                        Presionar TAB para Autocompletar los datos o haga clic en Buscar
                                    </div>
                                </div>
                                {viewDanger_local && <span className="text-danger">Debe ingresar el Local</span>}
                            </div>
                        </div>


                        <div className='row g-9 mb-8'>
                            <div className='col-md-6 fv-row fv-plugins-icon-container'>
                                <label className='fs-6 fw-bold mb-2'>Tipo de Motivo</label>
                                <SelectList
                                    apiService={Api.TipoMotivoList}
                                    args={{ token: token }}
                                    conditions={true}
                                    handleChange={(tipoMotivoX) => {
                                        setGetMotivosList(true);
                                        setRdmML(Math.floor(Math.random() * 100));
                                        return setTipoMotivo(tipoMotivoX)
                                    }}
                                    multiple={false}
                                    defaultSetterFunction={setTipoMotivo}
                                    setNextListEnable={setGetMotivosList}
                                />
                            </div>
                            <div className='col-md-6 fv-row fv-plugins-icon-container'>
                                <label className='fs-6 fw-bold mb-2'>Motivo</label>
                                <SelectList
                                    apiService={Api.MotivosList}
                                    args={{ tipoMotivo: tipoMotivo.value, token: token, rdmML: rdmML }}
                                    conditions={getMotivosList}
                                    setConditions={setGetMotivosList}
                                    handleChange={(motivoX) => setMotivo(motivoX)}
                                    multiple={false}
                                    defaultSetterFunction={setMotivo}
                                />
                            </div>
                        </div>

                        <div className='row g-9 mb-8'>
                            <div className='col-md-6 fv-row fv-plugins-icon-container'>
                                <label className='fs-6 fw-bold mb-2'>Responsable</label>
                                <input
                                    type="text"
                                    className="form-control form-control-solid"
                                    placeholder="Ingrese nombre completo"
                                    value={responsable}
                                    onChange={e => setResponsable(e.target.value)}
                                />
                                {viewDanger_responsable && <span className="text-danger">Debe ingresar el Responsable</span>}
                            </div>
                            <div className='col-md-6 fv-row fv-plugins-icon-container'>
                                <label className='fs-6 fw-bold mb-2'>Email en Copia (Locatario) <span className="text-danger">*</span></label>
                                <input
                                    type="email"
                                    className="form-control form-control-solid"
                                    placeholder="Ingrese email en copia"
                                    value={emailCopia}
                                    onChange={e => {
                                        setEmailCopia(e.target.value);
                                        if (viewDanger_emailCopia) setViewDanger_emailCopia(false);
                                    }}
                                />
                                {viewDanger_emailCopia && <span className="text-danger">Debe ingresar un correo electrónico válido</span>}
                            </div>
                        </div>

                        <div className='row g-9 mb-8'>
                            <div className='col-md-4 fv-row fv-plugins-icon-container d-flex flex-column'>
                                <label className='fs-6 fw-bold mb-2'>Fecha de Inicio</label>
                                <DatePicker
                                    wrapperClassName="w-100 d-block"
                                    className="form-control form-control-solid w-100"
                                    locale="es"
                                    selected={fechaInicio}
                                    onChange={(dateX) => setFechaInicio(dateX)}
                                    timeInputLabel="Time:"
                                    dateFormat="dd/MM/yyyy      h:mm aa"
                                    showTimeInput
                                />
                            </div>
                            <div className='col-md-4 fv-row fv-plugins-icon-container d-flex flex-column'>
                                <label className='fs-6 fw-bold mb-2'>Fecha de Fin</label>
                                <DatePicker
                                    wrapperClassName="w-100 d-block"
                                    className="form-control form-control-solid w-100"
                                    locale="es"
                                    selected={fechaFin}
                                    onChange={(dateX) => setFechaFin(dateX)}
                                    timeInputLabel="Time:"
                                    dateFormat="dd/MM/yyyy      h:mm aa"
                                    showTimeInput
                                />
                            </div>
                            <div className='col-md-4 fv-row fv-plugins-icon-container d-flex flex-column'>
                                <label className='fs-6 fw-bold mb-2'>Días de Penalidad</label>
                                <input
                                    type="number"
                                    className="form-control form-control-solid text-center"
                                    value={diasPenalidad}
                                    readOnly
                                />
                            </div>
                        </div>

                        <div className='row g-9 mb-8'>
                            <div className='col-md-4 fv-row fv-plugins-icon-container'>
                                <label className='fs-6 fw-bold mb-2'>TAM <span className="text-danger">*</span></label>
                                <input
                                    type="number"
                                    step="0.01"
                                    min="0.01"
                                    className="form-control form-control-solid"
                                    placeholder="Ingrese TAM"
                                    value={tam}
                                    onChange={e => {
                                        setTam(e.target.value);
                                        if (viewDanger_tam) setViewDanger_tam(false);
                                    }}
                                />
                                {viewDanger_tam && <span className="text-danger">Debe ingresar el TAM (monto mayor a 0)</span>}
                            </div>
                            <div className='col-md-4 fv-row fv-plugins-icon-container'>
                                <label className='fs-6 fw-bold mb-2'>Treintavo (1/30)</label>
                                <input
                                    type="text"
                                    className="form-control form-control-solid"
                                    value={treintavo}
                                    readOnly
                                />
                            </div>
                            <div className='col-md-4 fv-row fv-plugins-icon-container'>
                                <label className='fs-6 fw-bold mb-2'>Monto Final</label>
                                <input
                                    type="number"
                                    step="0.01"
                                    className="form-control form-control-solid"
                                    placeholder="Ingrese monto final"
                                    value={montoFinal}
                                    onChange={e => setMontoFinal(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className='d-flex flex-column mb-8 fv-row fv-plugins-icon-container'>
                            <label className='fs-6 fw-bold mb-2'>Detalle</label>

                            <textarea
                                type="text"
                                className="form-control form-control-solid"
                                placeholder="Descripción del incidente"
                                value={detalle}
                                onChange={e => setDetalle(e.target.value)}
                            />
                            {viewDanger_detalle && <span className="text-danger">Ingrese Detalle</span>}
                        </div>

                        <div className='d-flex flex-column mb-8 fv-row fv-plugins-icon-container'>
                            <label className='fs-6 fw-bold mb-2'>Adjuntar Documento</label>
                            <div className="d-flex align-items-center gap-3">
                                <label className="btn btn-primary cursor-pointer m-0">
                                    <i className="fi-rr-upload me-2"></i> Elegir Documento
                                    <input
                                        type="file"
                                        accept=".jpg,.jpeg,.png,.gif,.pdf"
                                        multiple
                                        style={{ display: 'none' }}
                                        onChange={handleFileChange}
                                    />
                                </label>
                                <span className="text-muted fs-7">Tamaño máximo: 5MB, formatos aceptados: jpg, jpeg, png, gif, pdf</span>
                            </div>
                            {pictures && pictures.length > 0 && (
                                <div className="d-flex flex-wrap gap-3 mt-3">
                                    {pictures.map((file, idx) => {
                                        const isPdf = file.name?.toLowerCase().endsWith('.pdf') || file.type?.includes('pdf');
                                        const isImage = file.type?.includes('image') || /\.(jpg|jpeg|png|gif)$/i.test(file.name);
                                        const previewUrl = isImage ? URL.createObjectURL(file) : null;

                                        return (
                                            <div key={idx} className="border rounded-3 p-3 d-flex align-items-center bg-light position-relative" style={{ minWidth: '280px', maxWidth: '360px' }}>
                                                {isPdf ? (
                                                    <div className="me-3 d-flex align-items-center justify-content-center bg-light-danger rounded-2 p-2" style={{ width: '48px', height: '48px', minWidth: '48px' }}>
                                                        <i className="fi-rr-document text-danger fs-2"></i>
                                                    </div>
                                                ) : isImage ? (
                                                    <img
                                                        src={previewUrl}
                                                        alt={file.name}
                                                        className="rounded-2 me-3"
                                                        style={{ width: '48px', height: '48px', minWidth: '48px', objectFit: 'cover' }}
                                                    />
                                                ) : (
                                                    <div className="me-3 d-flex align-items-center justify-content-center bg-light-primary rounded-2 p-2" style={{ width: '48px', height: '48px', minWidth: '48px' }}>
                                                        <i className="fi-rr-file text-primary fs-2"></i>
                                                    </div>
                                                )}
                                                <div className="flex-grow-1 overflow-hidden me-2">
                                                    <div className="fw-bold text-truncate fs-7" title={file.name}>{file.name}</div>
                                                    <div className="text-muted fs-8">{(file.size / (1024 * 1024)).toFixed(2)} MB</div>
                                                </div>
                                                <button
                                                    type="button"
                                                    className="btn btn-icon btn-sm btn-light-danger rounded-circle"
                                                    style={{ width: '24px', height: '24px', minWidth: '24px', padding: 0 }}
                                                    onClick={() => {
                                                        const newPictures = pictures.filter((_, i) => i !== idx);
                                                        setPictures(newPictures);
                                                    }}
                                                    title="Eliminar archivo"
                                                >
                                                    <i className="fi-rr-cross fs-8"></i>
                                                </button>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}

                        </div>
                        <button className="btn btn-primary" onClick={handleRegistrar}>Registrar</button>
                        {Boolean(registrar) && <Loading></Loading>}
                    </div>
                </div>

                <Modal
                    size="sm"
                    show={guardadoExitoso}
                    onHide={() => setGuardadoExitoso(false)}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Header>
                        <Modal.Title id="example-modal-sizes-title-sm" style={{ margin: 'auto' }}>
                            Guardado Exitoso
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Footer style={{ margin: 'auto' }}>
                        <button type="button" className="btn btn-primary" onClick={guardadoExistosoModal}>
                            Aceptar
                        </button>
                    </Modal.Footer>
                </Modal>

                <Modal
                    size="lg"
                    show={modalLocalesShow}
                    onHide={() => setModalLocalesShow(false)}
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title className="fw-bolder">
                            Buscar Local / Contrato
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="py-4">
                        <div className="mb-4">
                            <input
                                type="text"
                                className="form-control form-control-solid"
                                placeholder="Buscar por código de contrato o nombre de local..."
                                value={filterTextModal}
                                onChange={e => setFilterTextModal(e.target.value)}
                                autoFocus
                            />
                        </div>
                        <div className="table-responsive" style={{ maxHeight: '350px', overflowY: 'auto' }}>
                            <table className="table table-hover table-rounded table-striped border gy-3 gs-3 align-middle">
                                <thead className="bg-light sticky-top">
                                    <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
                                        <th style={{ width: '30%' }}>Código / Contrato</th>
                                        <th>Nombre de Local / Denominación</th>
                                        <th className="text-center" style={{ width: '20%' }}>Acción</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredLocales && filteredLocales.length > 0 ? (
                                        filteredLocales.map((item, index) => (
                                            <tr key={index}>
                                                <td className="fw-bold">{item.codContrato || item.contrato || item.value}</td>
                                                <td>{item.denCont || item.label || item.value}</td>
                                                <td className="text-center">
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-light-primary py-1 px-3 fs-7"
                                                        onClick={() => {
                                                            setLocalId(item.value);
                                                            setLocal(item.label || item.value);
                                                            setModalLocalesShow(false);
                                                        }}
                                                    >
                                                        <i className="fi-rr-check me-1 fs-7"></i> Seleccionar
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="3" className="text-center text-muted py-4">
                                                {listaLocalesSearch.length === 0
                                                    ? "Debe seleccionar un Mall primero."
                                                    : "No se encontraron coincidencias."}
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-light" onClick={() => setModalLocalesShow(false)}>
                            Cerrar
                        </button>
                    </Modal.Footer>
                </Modal>
            </PermissionsGate>

        </>
    )
}
